 import React from "react";
import moment from 'moment';
import axios from "axios";
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Popconfirm,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import {
	PlusOutlined,
	CloseOutlined,
} from "@ant-design/icons";
import $ from "jquery";
import { render } from 'react-dom';
import { withScriptjs } from 'react-google-maps';

import Axios from "axios";
import GoogleMap from "../GoogleMap"; 


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import deleteimg from '../../assets/images/icon/delete.png';


const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

function onChange_(date, dateString) {
  console.log(date, dateString);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}



function onBlur() {
  console.log('blur');
}

function onFocus() {
  console.log('focus');
}

function onSearch(val) {
  console.log('search:', val);
}

var uni_id = new Date().getTime();

const class_array = [
  { id: uni_id, document_name: "", file:"",is_delete:"0",from_date: "",to_date: "",},
];

const dateFormat = 'YYYY-MM-DD';

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			class_array: class_array,
			size: 'default',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			country_list: [],
			school_type: [],
			city_list: [],
			currency_list: [],
			gateway_list: [],
			school_list: [],
			school_location_list: [],
			location_list: [],
			visible: false,
			value: '',
			country: '',
			u_dise: '',
			u_dise_password: '',
			values: [],
			loading: false,
  		    iconLoading: false,
			user_id: '',
			name: '',
			type: '',
			country: '',
			school_location: '',
			city: '',
			locality: '',
			registration_no: '',
			zipcode: '',
			address: '',
			timezone: '',
			currency: '',
			admin_name: '',
			admin_number: '',
			slot: '',
			admin_email: '',
			admin_details: [],
			app_css:'',
			is_app:false,
			mtoken:null,
			iconLoading: false,
			location:'',
			prefix:'',
			payment_gateway:'',
			warehouse_location:'',
			dragging:false,
			is_open_map:1,
			oc_lattitude:'17.3850',
			oc_longitude:'78.4867'
			
		}
		this.onselectcountry = this.onselectcountry.bind(this);	
		this.onChangePayment = this.onChangePayment.bind(this);	
		this.onChangeWarehouse = this.onChangeWarehouse.bind(this);	
		this.onChangeLocation = this.onChangeLocation.bind(this);
		this.onselectcity = this.onselectcity.bind(this);	
		this.onselecttype = this.onselecttype.bind(this);	
		this.onselectcurrency = this.onselectcurrency.bind(this);	
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.onselecttime = this.onselecttime.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.goBack = this.goBack.bind(this);	
		this.EmailChange = this.EmailChange.bind(this);	
		this.PhoneChange = this.PhoneChange.bind(this);	
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		
		if(params.mtoken!=null){
			this.setState({ mtoken:params.mtoken,is_app:true,app_css:'app_css'});
			setTimeout(() => {
				document.querySelector(".loader-wrapper").style = "display: none";
				//this.checkData();
			}, 500);
		}
		else{
			this.setState({ is_app:false,app_css:''});
			setTimeout(() => {
				document.querySelector(".loader-wrapper").style = "display: none";
				//this.checkData();
			}, 500);
		}
		window.getGoogleMap = (lat,lng) => {
			this.setState({
				is_open_map:0
			});			
			setTimeout(() => {
				this.setState({
					is_open_map:1,
					oc_lattitude: lat,
					oc_longitude: lng,
				});
			}, 500);
		}
		
		this.checkLocation();
		this.checkData();
	}
	
	checkLocation=()=>{
		setTimeout(() => {
			if(document.getElementById('search_location_2')){
				const $ = window.$;
				const google = window.google;
				var geocoder;
				var map;
				var marker;
				var autocomplete;
				if(document.getElementById('search_location_2')){
					var search_location_2=document.getElementById('search_location_2');
				}
				else{
					var search_location_2= '';
				}		
				function get_location() {
					autocomplete = new google.maps.places.Autocomplete(
					(document.getElementById('search_location_2')),
					{ types: ['geocode'] });
					window.google.maps.event.addListener(search_location_2, 'place_changed', function() {
					});
				}
				
				if(document.getElementById('search_location_2')){
					var lat = '';
					var lng = '';
					
					if(document.getElementById('search_location_2')){
					   var input = document.getElementById('search_location_2');
					   var autocomplete = new google.maps.places.Autocomplete(input);
						google.maps.event.addListener(autocomplete, 'place_changed', function () {
							var place = autocomplete.getPlace();
							var lat  = place.geometry.location.lat();
							var lng = place.geometry.location.lng();
							document.getElementById('search_latitude_2').value = place.geometry.location.lat();
							document.getElementById('search_longitude_2').value = place.geometry.location.lng();
							document.getElementById('search_addr_2').value = place.formatted_address;
							window.getGoogleMap(lat,lng);
							initialize(lat,lng);
						});
					}
					initialize(lat,lng);
					function initialize(lat,lng) {
						if(document.getElementById('search_latitude_2')){
							var initialLat = document.getElementById('search_latitude_2').value
						}
						if(document.getElementById('search_longitude_2')){
							var initialLong = document.getElementById('search_longitude_2').value
						}
						if(lat==''){
							initialLat = initialLat?initialLat:17.3850;
							initialLong = initialLong?initialLong:78.4867;
						}
						else{
							initialLat = lat;
							initialLong = lng;
						}
						var latlng = new google.maps.LatLng(initialLat, initialLong);
						var options = {
							zoom: 16,
							center: latlng,
							mapTypeId: google.maps.MapTypeId.ROADMAP
						};
						map = new google.maps.Map(document.getElementById("geomap"), options);
						geocoder = new google.maps.Geocoder();
						marker = new google.maps.Marker({
							map: map,
							draggable: true,
							position: latlng
						});
						window.google.maps.event.addListener(marker, "dragend", function () {
							var point = marker.getPosition();
							map.panTo(point);
							geocoder.geocode({'latLng': marker.getPosition()}, function (results, status) {
								if (status == google.maps.GeocoderStatus.OK) {
									map.setCenter(results[0].geometry.location);
									marker.setPosition(results[0].geometry.location);
									document.getElementById('search_addr_2').value=results[0].formatted_address;
									document.getElementById('search_latitude_2').value=marker.getPosition().lat();
									document.getElementById('search_longitude_2').value=marker.getPosition().lng();
									window.getGoogleMap(marker.getPosition().lat(),marker.getPosition().lng());
								}
							});
						});
					}
				}
				
			}
		}, 1000);
	}
	
	reverseLookup = (lat, lng) => {	
		var app = {
			latitude: lat,
			longitude: lng
		} 
		getData('auth/place_reverse',app).then((result) => {
			if(result.status==200){
			   document.getElementById('search_location_2').value = result.data;
			   document.getElementById('search_addr_2').value = result.data;
			   this.setState({ location: result.data, dragging: false });
			}
		});
	};

	onMarkerDragEnd = (map) => {
		document.getElementById('search_latitude_2').value = map.center.lat();
		document.getElementById('search_longitude_2').value = map.center.lng();
		this.reverseLookup(map.center.lat(), map.center.lng());
	}; 
	
	handleDragging = () => {
		this.setState({ dragging: true });
		//this.refs.confirmGpsLocation.style.height = "44.7vh";
	};
	
	checkData(){
  	    if(this.state.is_app==true){
			//var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			//this.setState({ user_id : storedArray['data'][0]['user_id'] });
			//var user_id = storedArray['data'][0]['user_id'];
			let school_id = this.props.match.params.id;
			var app = {user_id : this.state.mtoken,school_id:this.props.match.params.id,is_app:true}
			getData('erp/master_school_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_school: result['total_school'],
							name: result['data']['0']['name'],
							type: result['data']['0']['type'],
							address: result['data']['0']['address'],
							country: result['data']['0']['country'],
							city: result['data']['0']['city'],
							locality: result['data']['0']['locality'],
							zipcode: result['data']['0']['zipcode'],
							currency: result['data']['0']['currency'],
							timezone: result['data']['0']['timezone'],
							u_dise: result['data']['0']['u_dise'],
							u_dise_password: result['data']['0']['u_dise_password'],
							slot: result['data']['0']['slot'],
							admin_details: result['data']['0']['admin_details'],
							location: result['data'][0]['location'],
							oc_lattitude: result['data'][0]['latitude'],
							registration_no: result['data'][0]['registration_no'],
							oc_longitude: result['data'][0]['longitude'],
							payment_gateway: result['data'][0]['payment_gateway'],
							prefix: result['data'][0]['prefix'],
							school_location: result['data'][0]['school_location'],
							warehouse_location: result['data'][0]['warehouse_location'],
						});
						const count = result['data'][0]['admin_details']
						const lenght_ = count.length;
						setTimeout(() => {
							this.setState({
								values:  result['data'][0]['admin_details'],
							   class_array: result['data'][0]['doc_details'],
							});
						}, 100);
						
					}else{
						this.setState({
							school_list: [],
							total_school: 0,
						});
					}
				}
			});
			getData('auth/country_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							country_list: result['data'],
						});
					}else{
						this.setState({
							country_list: [],
						});
					}
				}
			});
			
			getData('auth/payment_gateway_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							gateway_list: result['data'],
						});
					}else{
						this.setState({
							gateway_list: [],
						});
					}
				}
			});
			
			getData('auth/school_location_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_location_list: result['data'],
						});
					}else{
						this.setState({
							school_location_list: [],
						});
					}
				}
			});
			
			getData('auth/school_type',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_type: result['data'],
						});
					}else{
						this.setState({
							school_type: [],
						});
					}
				}
			});
			getData('auth/currency_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							currency_list: result['data'],
						});
					}else{
						this.setState({
							currency_list: [],
						});
					}
				}
			});
		
	 }
	 else if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			let school_id = this.props.match.params.id;
			var app = {user_id : user_id,school_id:this.props.match.params.id}
			getData('erp/master_school_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_school: result['total_school'],
							name: result['data']['0']['name'],
							type: result['data']['0']['type'],
							address: result['data']['0']['address'],
							country: result['data']['0']['country'],
							city: result['data']['0']['city'],
							locality: result['data']['0']['locality'],
							zipcode: result['data']['0']['zipcode'],
							currency: result['data']['0']['currency'],
							timezone: result['data']['0']['timezone'],
							u_dise: result['data']['0']['u_dise'],
							u_dise_password: result['data']['0']['u_dise_password'],
							slot: result['data']['0']['slot'],
							admin_details: result['data']['0']['admin_details'],
							registration_no: result['data']['0']['registration_no'],
							location: result['data'][0]['location'],
							oc_lattitude: result['data'][0]['latitude'],
							oc_longitude: result['data'][0]['longitude'],
							prefix: result['data'][0]['prefix'],
							payment_gateway: result['data'][0]['payment_gateway'],
							school_location: result['data'][0]['school_location'],
							warehouse_location: result['data'][0]['warehouse_location'],
						});
						setTimeout(() => {
							this.setState({
								values:  result['data'][0]['admin_details'],
							   class_array: result['data'][0]['doc_details'],
							});
						}, 100);
						
						const count = result['data'][0]['admin_details']
						const lenght_ = count.length;
						
						
							
						
					}else{
						this.setState({
							school_list: [],
							total_school: 0,
						});
					}
				}
			});
			getData('auth/country_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							country_list: result['data'],
						});
					}else{
						this.setState({
							country_list: [],
						});
					}
				}
			});
			
			getData('auth/payment_gateway_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							gateway_list: result['data'],
						});
					}else{
						this.setState({
							gateway_list: [],
						});
					}
				}
			});
			
			getData('auth/warehouse_location_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							location_list: result['data'],
						});
					}else{
						this.setState({
							location_list: [],
						});
					}
				}
			});
			
			getData('auth/school_location_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_location_list: result['data'],
						});
					}else{
						this.setState({
							school_location_list: [],
						});
					}
				}
			});
			
			getData('auth/school_type',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_type: result['data'],
						});
					}else{
						this.setState({
							school_type: [],
						});
					}
				}
			});
			getData('auth/currency_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							currency_list: result['data'],
						});
					}else{
						this.setState({
							currency_list: [],
						});
					}
				}
			});
		
	 }
  }
  
 handleSubmit=(e)=>{
    e.preventDefault();
    this.setState({ loading: true });
    const lenght = this.state.admin_details.length - 1;
	    var admin_name = [];
		
		
		for (var i = 0; i < lenght; i++) {
			 admin_name[i]= document.getElementById('admin_name_'+i).value; 
		}
		
		var admin_number = [];
		for (var i = 0; i < lenght; i++) {
			 admin_number[i]= document.getElementById('admin_number_'+i).value; 
		}
        var admin_email = [];
		for (var i = 0; i < lenght; i++) {
			 admin_email[i]= document.getElementById('admin_email_'+i).value; 
		}
        var admin_id = [];
		for (var i = 0; i < lenght; i++) {
			 admin_id[i]= document.getElementById('admin_id_'+i).value; 
		}
		
		
		
		var location = document.getElementById('search_location_2').value;
		var latitude = document.getElementById('search_latitude_2').value;
		var longitude = document.getElementById('search_longitude_2').value;
		
		var app = {
			warehouse_location: this.state.warehouse_location ,
			id: this.props.match.params.id,
			user_id: this.state.user_id,
			slot: this.state.slot,
			name: this.state.name,
			type: this.state.type,
			country: this.state.country,
			registration_no: this.state.registration_no,
			city: this.state.city,
			locality: this.state.locality,
			zipcode: this.state.zipcode,
			address: this.state.address,
			timezone: this.state.timezone,
			currency: this.state.currency,
			u_dise: this.state.u_dise,
			u_dise_password: this.state.u_dise_password,
			payment_gateway: this.state.payment_gateway ,
			school_location: this.state.school_location ,
			prefix: this.state.prefix ,
			admin_name: admin_name,
			admin_number: admin_number,
			admin_email: admin_email,
			admin_id: admin_id,
			location : location,
			latitude : latitude,
			longitude : longitude,
		}
		
      getData('erp/master_edit_school',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            const data = new FormData();
				const class_array = this.state.class_array;
				for(let i = 0; i < class_array.length; i++) {
					data.append(`doc_id[${i}]`, class_array[i].id);
					data.append(`is_delete[${i}]`, class_array[i].is_delete);
					data.append(`document_name[${i}]`, class_array[i].document_name);
					data.append(`file[${i}]`, class_array[i].file);
					data.append(`from_date[${i}]`, class_array[i].from_date);
					data.append(`to_date[${i}]`, class_array[i].to_date);
				}
				
				data.append("id", this.props.match.params.id);
				data.append("type", "school");
				data.append("user_id", this.state.user_id);
				
				let url = "https://kcisapi.kidzonia.co.in/v1/erp/upload_school_documents";
				axios.post(url, data, {}).then((res) => {
					this.setState({
						loading: true
					});
					message.config({
						top: 150
					});
					message.config({ top: 150});
					message.success('School Updated',2);
					this.setState({ loading: false });
					this.setState({comment_text:''});
					window.location.href = '/my-school';
				});

          }
      }); 

	}
  
	onselectcountry(e) {
		
	  this.setState({ 'country' : e });
	  
		var user_id = this.state.user_id;
		var country_id = e;
		var app = {user_id : user_id,country_id:country_id}
	  getData('franchise/country_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							city_list: result['data'],
						});
					}else{
						this.setState({
							city_list: [],
						});
					}
				}
			});
	}
	
	onChangePayment(e) {
	  this.setState({ 'payment_gateway' : e });
	}
	
	onChangeWarehouse(e) {
	  this.setState({ 'warehouse_location' : e });
	}
	
	onChangeLocation(e) {
	  this.setState({ 'school_location' : e });
	}
	
  onselectcity(e) {
	  this.setState({ 'city' : e });
	}	
  onselecttype(e) {
	  this.setState({ 'type' : e });
	}	
	
	onselectcurrency(e) {
	  this.setState({ 'currency' : e });
	}
	
	onselecttime(e) {
	  this.setState({ 'timezone' : e });
	}

	 handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };
	  
	   EmailChange = (i,e) => {
		 var id = 'prnt_email_'+i;
		 var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		 if (pattern.test(e.target.value)) {
			document.getElementById(id).innerHTML = "";
			document.getElementById("submit_btn").disabled = false;
		  }else{
			document.getElementById(id).innerHTML = "Please Enter Valid Email !!!";
			document.getElementById("submit_btn").disabled = true;
		  }
	  
	  };
	  
	  PhoneChange = (i,e) => {
		var id = 'prnt_mobile_'+i;
		 var pattern = new RegExp(/^[0-9\b]+$/);
		 if (!pattern.test(e.target.value)) {
			document.getElementById(id).innerHTML = "Please Enter Only Number !!!";
			document.getElementById("submit_btn").disabled = true;
		  }else if(e.target.value.length != 10){
			document.getElementById(id).innerHTML = "Please Enter Valid Phone Number. !!!";
			document.getElementById("submit_btn").disabled = true;
		  }else{
			document.getElementById(id).innerHTML = "";
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
			document.getElementById("submit_btn").disabled = false;
			
		  }
	  };
	  
	  
  handleChange = ({ fileList }) => this.setState({ fileList });
	
	createUI(){
	 const lenght = this.state.values.length;
	 const lenght_1 = this.state.admin_details.length - 1;
     return this.state.admin_details.map((el, i) => 
         <div class="col-md-12" key={i}>
		 <div class="row">	
										<input type="hidden" value={this.state.admin_details[i].admin_id} name={`admin_id_${i}`}  id={`admin_id_${i}`} />
										<div class="col-md-4 mb-10 form-group">
											<label>First Name</label>
											<input type="text" class="form-control" defaultValue={this.state.admin_details[i].admin_name} name={`admin_name_${i}`}  id={`admin_name_${i}`}   required/>
										</div>	
										<div class="col-md-3 mb-10 form-group" >
											<label>Phone Number</label>
											<input type="text" class="form-control" defaultValue={this.state.admin_details[i].admin_number}  name={`admin_number_${i}`}  id={`admin_number_${i}`} required/>
											<span class="error" id={`prnt_mobile_${i}`} ></span>
										</div>	
										<div class="col-md-3 mb-10 form-group">
											<label>Email</label>
											<input type="text" class="form-control" defaultValue={this.state.admin_details[i].admin_email}   name={`admin_email_${i}`}  id={`admin_email_${i}`}  required/>
											<span class="error" id={`prnt_email_${i}`} ></span>
										</div>
									{(() => {
							  
								if (lenght_1 == i) {
								return (
										<>
												<div class="col-md-2 pt-2 mt-4">
												<Popconfirm
														title="Are you sure delete?"
														onConfirm={this.removeClick.bind(this,i,this.state.admin_details[i].admin_id)}
														okText="Yes"
														cancelText="No"
													  >
														<Button className="btn btn-primary new-btn">Remove</Button>
											   </Popconfirm>
												
													 
												</div>
												
										</>
									)
									}
								})()}
         </div>          
         </div>          
     )
  }
  

  
  addClick(){
    
	var myArray = {admin_id: 0, admin_name: '', admin_number: '',admin_email:''};
    this.setState(prevState => ({ admin_details: [...prevState.admin_details, myArray]}));
	setTimeout(() => {
			console.log('array',this.state.admin_details);
	}, 500);
	
  }
  
  removeClick(i,admin_id){
	 var app = {
				admin_id: admin_id ,
				user_id: this.state.user_id ,
			}
      getData('erp/master_school_admin_delete',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error('Not Deleted !!',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Deleted Successfully !!',2);
              this.setState({ loading: false });
              let admin_details = [...this.state.admin_details];
			  admin_details.splice(i,1);
			  this.setState({ admin_details });

          }
      });
    }
	
	addRow = (current_row) => {
		var flag = 0;
		var class_array = this.state.class_array
		for (var i = 0; i < class_array.length; i++) {
		  if (class_array[i].document_name == "") {
			message.config({ top: 150 });
			message.error("Please Enter Document Name", 2);
			return false;
			flag = 1;
			break;
		  }
		}
		setTimeout(() => {
		  if (flag == 0) {
			var uni_id = new Date().getTime();
			var row = {
			  id: uni_id,
			  document_name: "",
			  file: "",
			  file_view: "",
			  is_delete: "0",
			};

			class_array.push(row);
			this.setState({
			  row_id: uni_id,
			  selected_row: uni_id,
			  class_array: class_array,
			});
		  }
		}, 100);
	};

	removeRow = (current_row,id,is_delete) => {
		if(is_delete == '1'){
			//alert('1');
			var app = {id : id}
			getData('erp/delete_school_docs',app).then((result) => {
				if(result['status'] == 200){
					message.config({ top: 150});
					message.success('Document Deleted Successfully !!',2);
					setTimeout(() => {
						this.checkData();
					}, 500);
				}
			});
			
		}else{
			var class_array = this.state.class_array
			if (class_array.length == 1) {
			  message.config({ top: 150 });
			  message.error("Alert! Atleast 1 Document is Required", 2);
			  return false;
			} else {
			  for (var i = 0; i < this.state.class_array.length; i++) {
				if (class_array[i].id === current_row) {
				  class_array.splice(i, 1);
				  break;
				}
			  }
			  this.setState({
				class_array: class_array,
			  });
			}
		}
		
	};
	
	change_file(current_row, file) {
		var class_array = this.state.class_array
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
		    var size = file.target.files[0].size;
			if(size > 4100000) {
				message.config({ top: 150 });
				message.error("Sorry!..You Can't Upload more then 4MB!", 2);
				return false;
			}else{
				class_array[i].file = file.target.files[0];
				$('#file_preview_'+current_row).html('1 file selected');
				this.setState({
				  class_array: class_array,
				});
				break;
			}
		  }
		}
	}
	
	change_note(current_row, note) {
		var class_array = this.state.class_array
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
			class_array[i].document_name = note.target.value;
			this.setState({
			  class_array: class_array,
			});
			break;
		  }
		}
	}
	
	
	fromDateChange(current_row, date, dateString) {
		var class_array = this.state.class_array
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
			class_array[i].from_date = dateString;
			this.setState({
			  class_array: class_array,
			});
			break;
		  }
		}
	}
	
	toDateChange(current_row, date, dateString) {
		var class_array = this.state.class_array
		for (var i = 0; i < class_array.length; i++) {
		  if (current_row == class_array[i].id) {
			class_array[i].to_date = dateString;
			this.setState({
			  class_array: class_array,
			});
			break;
		  }
		}
	}
  
  
  goBack(){
		window.location.href = '/my-school/index';
	}
	
	render()
	
	{
		
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     
					
		return (
		<>
		    {this.state.is_app==false && (
                <div class="row bred">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i>Edit School
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/my-school`} class="router-link-active" target="_self">My School </a></li>
								<li class="breadcrumb-item"> Edit School </li>
							</ol>
						</div>
					</h4>
				</div>
				</div>
				</div>
			</div>
             )}
			
			
			
			<div className={`mobile_view ${this.state.app_css}`}>
			
			<div id="main" class="bg-off">
         <div class="row">
		
			<div class="col-md-12 ex-padd">
            {this.state.school_list.map((list) => (
			
            <div class="view-Profile child-profile">
			   <div class="col-md-12 mb-20 card-content iq-card  mobile-no-padd">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Edit School" classname="as" key="1">
						 <div class="row">
						    <div class="col-md-12">
							<div class="row">
								<div class="col-md-4 mb-10 form-group">
									<label>School Name</label>
									<input type="text"  class="form-control" value={this.state.name}  name="name" id="name" onChange={this.handleSizeChange} required/>
								</div>	
								<div class="col-md-4 mb-10 form-group" >
									<label>U-Dise Code</label>
									<input type="text" class="form-control"  name="u_dise"  value={this.state.u_dise} onChange={this.handleSizeChange} required/>
								</div>	
								<div class="col-md-4 mb-10 form-group" >
									<label>U-Dise Password</label>
									<input type="text" class="form-control"  name="u_dise_password"  value={this.state.u_dise_password} onChange={this.handleSizeChange} required/>
								</div>	
								<div class="col m4  s12 mb-10 form-group">
									<label>Type</label>
									<Select
										showSearch
										style={{ width: 200 }}
										placeholder="Select a Type"
										optionFilterProp="children"
										onChange={this.onselecttype}
										onFocus={onFocus}
										onBlur={onBlur}
										onSearch={onSearch}
										defaultValue={list.type}
										name="type"
										id="type"
										required
									  >
										{this.state.school_type.map((type) => (
										<Option value={type.name} >{type.name}</Option>
										))}
									  </Select>			
								</div>	
							</div>	
							</div>	
							<div class="col-md-12">
							<div class="row">
								<div class="col-md-4 mb-10 form-group">
									<label>Country</label>
									
									<Select
										showSearch
										style={{ width: 200 }}
										placeholder="Select a Country"
										optionFilterProp="children"
										onChange={this.onselectcountry}
										onFocus={onFocus}
										onBlur={onBlur}
										onSearch={onSearch}
										defaultValue={list.country}
										name="country"
										id="country"
										required
									  >
										{this.state.country_list.map((list) => (
										<Option value={list.name}>{list.name}</Option>
										))}
									  </Select>									
								</div>
								<div class="col-md-4 mb-10 form-group">
									<label>City</label>
										<input type="text" class="form-control"  value={this.state.city}  name="city" id="city" onChange={this.handleSizeChange} required/>
								</div>
								<div class="col-md-4 mb-10 form-group">
									<label>Locality</label>
										<input type="text" class="form-control" value={this.state.locality}   name="locality" id="locality" onChange={this.handleSizeChange} required/>
								</div>								
							</div>	
						 
						
							
						<div class="col-md-12">
						<div class="row">
							<div class="col-md-8 mb-10 form-group">
								<label>Address</label>
								<input type="text" class="form-control"  value={this.state.address}  name="address" id="address" onChange={this.handleSizeChange} required/>
							</div>	
							<div class=" col-md-4 mb-10 form-group">
								<label>Slot</label>
								<input type="text" class="form-control"  name="slot" value={this.state.slot} onChange={this.handleSizeChange} required/>
							</div>		
													
						<div class="col-md-4 mb-10 form-group">
								<label>Zipcode</label>
								<input type="text" class="form-control" value={this.state.zipcode}   name="zipcode" id="zipcode" onChange={this.handleSizeChange} required/>
						</div>
						<div class="col-md-4 mb-10 form-group">
								<label>Currency</label>
								<Select
										showSearch
										style={{ width: 200 }}
										placeholder="Select a Currency"
										optionFilterProp="children"
										onChange={this.onselectcurrency}
										onFocus={onFocus}
										onBlur={onBlur}
										onSearch={onSearch}
										name="currency"
										id="currency"
										defaultValue={list.currency}
									  >
										{this.state.currency_list.map((list) => (
										<Option value={list.name}>{list.code}</Option>
										))}
									  </Select>	
						</div>
						<div class="col-md-4 mb-10 form-group">
								<label>Time Zone</label>
								<Select name="timezone" onChange={this.onselecttime} defaultValue={list.timezone} id="timezone" required>
									    <Select.Option value="(UTC +5:30) Chennai, Kolkata, Mumbai, New Delhi" >(UTC +5:30) Chennai, Kolkata, Mumbai, New Delhi</Select.Option>
										<Select.Option value="(UTC -4:00) Atlantic Time (Canada)">(UTC -4:00) Atlantic Time (Canada)</Select.Option>
										<Select.Option value="(UTC 4:00) Eastern Time (US & Canada)">(UTC 4:00) Eastern Time (US & Canada)</Select.Option>
										
								</Select>			
						</div>
						<div class="col-md-4 mb-10 form-group">
								<label>RE No.</label>
								<input type="text" class="form-control" name="registration_no" value={this.state.registration_no} onChange={this.handleSizeChange} required/>
						</div>
						
						<div class="col-md-4 mb-10 form-group">
								<label>Prefix</label>
								<input type="text" class="form-control" name="prefix" onChange={this.handleSizeChange} placeholder="eg. KC02/HYD" value={this.state.prefix} required/>
						</div>
						
						<div class="col-md-4 mb-10 form-group">
							<label>Payment Gateway</label>
							
							<Select
								showSearch
								defaultValue={list.payment_gateway_name}
								style={{ width: 200 }}
								placeholder="Select a Payment Gateway"
								optionFilterProp="children"
								onChange={this.onChangePayment}
								onFocus={onFocus}
								onBlur={onBlur}
								name="payment_gateway"
								required
							  >
								{this.state.gateway_list.map((list) => (
								<Option value={list.id}>{list.name}</Option>
								))}
							  </Select>									
						</div>
						
						<div class="col-md-4 mb-10 form-group">
							<label>Warehouse Location</label>
							
							<Select
								showSearch
								defaultValue={list.warehouse_location}
								style={{ width: 200 }}
								placeholder="Select a Warehouse Location"
								optionFilterProp="children"
								onChange={this.onChangeWarehouse}
								onFocus={onFocus}
								onBlur={onBlur}
								name="warehouse_location"
								required
							  >
								{this.state.location_list.map((list) => (
								<Option value={list.id}>{list.name}</Option>
								))}
							  </Select>									
						</div>
						
						<div class="col-md-4 mb-10 form-group">
							<label>Operated By</label>
							
							<Select
								showSearch
								defaultValue={list.school_location_name}
								style={{ width: 200 }}
								placeholder="School Location"
								optionFilterProp="children"
								onChange={this.onChangeLocation}
								onFocus={onFocus}
								onBlur={onBlur}
								name="school_location"
								required
							  >
								{this.state.school_location_list.map((list) => (
								<Option value={list.id}>{list.name}</Option>
								))}
							  </Select>									
						</div>
						
						</div>
						</div>
						</div>
						</div>
									
						</Panel>
					  </Collapse>
					</div> 
					
					<div class="children bg-blue communication bb pb-20 mb-20 iq-card2 bg-color-6">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Google Location"  key="1">
							<div class="row">
								<div class="col-md-12 card-content iq-card">
									<label>Google Location * </label>
									<input type="text" defaultValue={this.state.location} id="search_location_2" name="oc_location" class="form-control"/>
									<input type="text" defaultValue={this.state.oc_lattitude} type="hidden" id="search_latitude_2" />
									<input type="text" defaultValue={this.state.oc_longitude} type="hidden" id="search_longitude_2"  />
									<input type="text" defaultValue={this.state.location} type="hidden" id="search_addr_2" />
								</div>
								<div class="col-md-12 mb-20 card-content iq-card">
									<div class="map_div" style={{height: window.innerHeight - 200}}>
										<GoogleMap
											reverseLookup={this.reverseLookup}
											onMarkerDragEnd={this.onMarkerDragEnd}
											handleDragging={this.handleDragging}
											oc_lattitude={this.state.oc_lattitude}
											oc_longitude={this.state.oc_longitude}
											is_open_map={this.state.is_open_map}
										/>
										
									</div>
								</div>
							</div>
							
						</Panel>
					  </Collapse>
					</div>
					
					<div class="children bg-blue communication bb pb-20 mb-20 iq-card2 bg-color-6">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Principal Details"  key="1">
							<div class="meal  mb-20 text-center">
								 <Button className="btn btn-primary new-btn mr-2" onClick={this.addClick.bind(this)}>Add Details</Button>
							</div>
							
							
							
							{this.createUI()}  
							
						</Panel>
					  </Collapse>
					</div>

					<div class="children bg-blue communication bb pb-20 mb-20 iq-card2 bg-color-6">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Documents" key="1">
					<div class={`children  mb-20 iq-card2 mh-400 mt-20`} >
						<table class="table white border-radius-4 pt-1 table_border admission dairy-table form-group">
							<thead>
								<tr>
									<th class="dairy-table-td">Document Name</th>	
									<th class="dairy-table-td">From Date</th>
									<th class="dairy-table-td">To Date</th>
									<th class="dairy-table-td">Upload File</th>
									<th class="dairy-table-last-td">Action</th>
								</tr>
							</thead>
							<tbody >
								{this.state.class_array.map((row, index) => (
									<tr key={index}>
										<td>
											<input
											    onChange={this.change_note.bind(this,row.id)}
												name="document_name"
												id="document_name"
												defaultValue={row.document_name}
											/>
										</td>
										<td>	
											{row.from_date!='' ? (<>
												<input type="hidden" />
												<DatePicker onChange={this.fromDateChange.bind(this,row.id)} defaultValue={moment(row.from_date, dateFormat)}/>
											</>) : (<>
												<DatePicker onChange={this.fromDateChange.bind(this,row.id)} />
											</>)}
											
										</td>
										<td>
											{row.to_date!='' ? (<>
												<input type="hidden" />
												<DatePicker onChange={this.toDateChange.bind(this,row.id)} defaultValue={moment(row.to_date, dateFormat)}/>
											</>) : (<>
												<DatePicker onChange={this.toDateChange.bind(this,row.id)} />
											</>)}	
											
										</td>
										<td>
											<div class="row">
											<div class="col-md-6 ">
												<label class="ant-btn snd-btn ipt-10" for={`file_${row.id}`} id={`file_preview_${row.id}`}>Choose File</label>
												<input id={`file_${row.id}`} type="file" accept=".pdf,image/*" name="file" onChange={this.change_file.bind(this,row.id)} style={{display: 'none',opacity: '0'}}/>	
											</div>
											{row.file_view !='' && (
												<div class="col-md-6">
													<a href={row.file_view} target="_blank">
														View file
													</a>
												</div>
											)}
											</div>
										</td>
										<td>
											
															{(() => {
																if (index > 0) {
																return (
																	<div class="" style={{'display':'-webkit-inline-box'}}>
																	  <div class="col-md-12 text-left no-padd ">
																			<Button className="ant-btn btn btn-primary new-btn remove-btn ml-0 mb-0 float-left" onClick={this.removeRow.bind(this,this.state.row_id,row.id,row.is_delete)}><CloseOutlined /></Button>
																		</div>
																	</div>
																	)
																}
															})()}
													
										</td>
									</tr>
								))}
								 
								<tr>
									<td class="center" colspan="6">
										<div class="" style={{'display':'-webkit-inline-box'}}>
										  <div class="col-md-12 text-center add-btn text-left no-padd">
												<Button className="ant-btn btn btn-primary new-btn ml-0 mb-0 float-left" onClick={this.addRow.bind(this,this.state.row_id)} ><PlusOutlined />Add</Button>
											</div>
										</div>
									</td>
								</tr>
							</tbody>	
						</table>
					</div> 
					</Panel>
					  </Collapse>
					</div>	

					
						
					
					
					<div class="meal mt-20  pt-20 bt text-center">
						 <Button className="btn btn-primary mr-2" id="submit_btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
						  <Button className="btn btn-primary new-btn mr-2" onClick={this.goBack}>Back</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
			
			))}
			
         </div>
		 
         </div>
      </div>
     
			</div>
			</>
		) 
	} 
}
export default Index;
